import * as Darby from './darby_alerts';

/*** Product ***/
(function() {
  // Variables
  // =========
  let initialized = false;
  let $categoryResults = $('#category_results');

  // Methods
  // =======
  function init(){
    if (!initialized){
      initialized = true;
      getProducts();
    }
  }

  function toggleCategory() {
    let $categoryButton = $(this);
    $('#category_list button.button').attr('class', 'button badge-pill badge-primary');
    $categoryButton.attr('class', 'button badge-pill badge-success');
    getProducts();
  }

  function collapseAll(){
    $('.collapse').collapse('hide');
  }

  function showModal(){
    const $selectedButton = $(this);
    const $options_modal = $selectedButton.next()
    Darby.showModal($options_modal);
  }

  function getProducts(){
    let page = 1;
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let categoryIds = $('#category_list button.badge-success').map(function(){
      return $(this).val();
    }).get();
    let productCard = $categoryResults.attr('data-product-card');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/products/category_products',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          category_ids: categoryIds,
          card: productCard,
          page: page,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          $categoryResults.html(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function toggleModifier() {
    let $selectedModifierButton = $(this);
    let $modifier = $selectedModifierButton.parent();
    let $modifierButtons = $modifier.children('button');
    if ($selectedModifierButton.attr('class') === 'button badge-pill badge-secondary modifier-product') {
      if (parseInt($modifier.attr('data-max')) === 1) {
        $modifierButtons.attr('class', 'button badge-pill badge-secondary modifier-product');
      }
      if ($modifierButtons.filter('.badge-success').length < parseInt($modifier.attr('data-max'))) {
        $selectedModifierButton.attr('class', 'button badge-pill badge-success modifier-product');
      } else {
        Darby.alertModal($modifier.attr('data-max') + ' Max for this modifier. Look at other modifiers for more options.');
      }
    } else if ($modifierButtons.filter('.badge-success').length > parseInt($modifier.attr('data-min'))) {
      $selectedModifierButton.attr('class', 'button badge-pill badge-secondary modifier-product');
    }
  }

  function getModifiers($productButton) {
    let data = {
      message: "",
      modifiers: [],
    };
    let $modifierGroups = $('#modifiers' + $productButton.attr('data-product_id')).find('div.btn-group-toggle');
    $modifierGroups.each(function () {
      let modifier = {
        modifier_id: $(this).attr('data-modifier'),
        selected: [],
      }
      let $selectedButtons = $(this).children('button.badge-success');
      if ($selectedButtons.length < parseInt($(this).attr('data-min'))) {
        data.message += 'Need to select at least ' + $(this).attr('data-min') + ' from ' + $(this).attr('data-title') + '\n';
      }
      $selectedButtons.each(function () {
        modifier.selected.push($(this).attr('data-product'));
        let $customValues = $(this).next('input.custom_amount');
        $customValues.each(function () {
          if ($(this).val() <= 0){
            data.message += 'Invalid Custom Value. \n';
          } else {
            modifier.selected.push($(this).attr('id') + ' ' + $(this).val());
          }
        })
      })
      data.modifiers.push(modifier);
    });
    if (data.message !== '') {
      Darby.alertModal(data.message);
    }
    return data;
  }

  function addToOrder() {
    const $productButton = $(this);
    let modifierObject = getModifiers($productButton);
    if (modifierObject.message === '') {
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      let productId = $productButton.attr("data-product_id");
      let quantity = $('#quantity' + productId).val();
      $('#quantity' + productId).val('1');
      let notes = $('#notes' + productId).val();
      $('#notes' + productId).val('');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/orders/add',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            product_id: productId,
            quantity: quantity,
            notes: notes,
            modifiers: modifierObject.modifiers,
            requestUri: '/orders/add',
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error'){
              Darby.alertModal(data.message);
            } else {
              $('#order').html(data.order_html);
              $('#order_options').html(data.order_options_html);
              $('.cart').replaceWith(data.order_cart);
              $('.collapse').collapse('hide');
              if (data.redirect){
                window.location.replace(data.redirect);
              }
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            Darby.alertModal('Oops! An error occured');
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      );
    }
  }

  function sendReceipt() {
    let $receiptButton = $(this);
    let modifierObject = getModifiers($receiptButton);
    if (modifierObject.message === '') {
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      let orderId = $receiptButton.attr('data-order_id');
      let message = $('#message' + orderId).val();
      $('#message' + orderId).val('');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/orders/send_receipt_modal',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            order_id: orderId,
            message: message,
            modifiers: modifierObject.modifiers,
            requestUri: '/orders/send_receipt_modal',
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error'){
              Darby.alertModal(data.message);
            } else {
              // Darby.alertModal(data.message);
              $('.collapse').collapse('hide');
              if (data.redirect){
                window.location.replace(data.redirect);
              }
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            Darby.alertModal(textStatus);
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      );
      /*
      if(document.getElementsByTagName('main')[0].id == "gen2"){
        // normalModal();
      } else {return}

       */
    }

  }

  function deleteFromOrder() {
    let deleteProduct = $(this).attr('data-product_id');
    // console.log(deleteProduct);
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/orderProducts/itemDelete',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          orderProduct_id: deleteProduct,
          quantity: 1,
          // modifiers: modifierObject.modifiers,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error'){
            Darby.alertModal(data.message);
          } else {
            $('#order').html(data.order_html);
            $('#order_options').html(data.order_options_html);
            $('.cart').replaceWith(data.order_cart);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          window.location.href = "/login";
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  // Events
  // ======

  // Buttons are not on the screen when the page is loaded
  // so need to attach the event to something that is there when loaded.

  // Product Categories in the Store
  const $categoryList = $('#category_list');
  $categoryList.on('click', 'button', toggleCategory);
  // Product Results of toggling Category
  // $categoryResults.on('click', 'button.pos-product', collapseAll);
  // $categoryResults.on('click', 'button.order-product', collapseAll);
  $categoryResults.on('click', 'button.pos-product', showModal);
  $categoryResults.on('click', 'button.order-product', showModal);
  $categoryResults.on('click', 'button.add-to-order', addToOrder);
  $categoryResults.on('click', 'button.modifier-product', toggleModifier);
  // For Product buttons on the page when loaded outside category_results
  $('button.pos-product').on('click', showModal);
  $('button.order-product').on('click', showModal);
  $('button.add-to-order').on('click', addToOrder);
  $('button.modifier-product').on('click', toggleModifier); // In Products and Receipt Modals
  // Other order options
  $('button.receipt-options').on('click', showModal);
  $('button.send-receipt').on('click', sendReceipt); // In receipt modal
  $('#order').on('click', '.del-from-order', deleteFromOrder);

  if ( $categoryList.length ) {
    init();
  }

})();

